import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { AppUnbilledArAging } from "src/components/unbilledArAgingPage/unbilled-ar-aging-page";

export function UnbilledArAging() {
  const [navigationOpen, setNavigationOpen] = React.useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);

  return (
    <AppLayout
      disableContentPaddings
      content={<AppUnbilledArAging />}
      navigation={<Navigation activeHref={URLS.UNBILLED_AR_AGING} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      toolsOpen={toolsOpen}
      onToolsChange={({ detail }) => setToolsOpen(detail.open)}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
